import { render } from "./App.vue?vue&type=template&id=0309abe8"
const script = {}

import "./App.vue?vue&type=style&index=0&id=0309abe8&lang=scss"

import exportComponent from "/Users/migueljr/Desktop/santosapato/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__